export default {"src":"/_next/static/media/PROPHETMARKET.030bc450.svg","height":153,"width":642,"blurWidth":0,"blurHeight":0};